// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"505":"35c1db73","2218":"e9b296bc","3601":"93024220","5440":"35c1db73"}[chunkId] + ".chunk.css";
};